




























import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { getValueAndUnit, unitsTypes } from '../api/ValuesHelper';
import { booleanFormatter, isNullOrEmpty } from '../utils';

@Component({
    components: {}
})
export default class IndicatorValue extends Vue {
    @Prop({default: ''}) label: string;
    @Prop({default: ''}) infoText: string;
    @Prop({default: null}) unit: unitsTypes;
    @Prop({default: false}) customValue: boolean;
    @Prop({default: null}) value: string | null;
    @Prop({default: "127"}) minWidth: string;


    getValueParsed(value, unit){
       return getValueAndUnit(value, unit)
    }
   

}
